import { DataBean } from "../../DataBean";


export class HealthContractType extends DataBean {

    public async getHealthContractTypeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthContractTypeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}